export const escapeCSVField = (value) => {
    if (!value) {
        return '';
    }
    if (value.includes(',') || value.includes('"') || value.includes('\n')) {
        return `"${value.replace(/"/g, '""')}"`;
    }
    return value;
};
export const parseNoteTileHtml = (html) => {
    if (!html) {
        return { heading: null, body: null };
    }
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const headingElement = doc.querySelector('h1, h2');
    const heading = headingElement?.textContent?.trim() || null;
    const paragraphs = doc.querySelectorAll('p');
    const bodyParts = [];
    paragraphs.forEach(p => {
        const text = p.textContent?.trim();
        if (text) {
            bodyParts.push(text);
        }
    });
    const body = bodyParts.length > 0 ? bodyParts.join('\n') : null;
    return { heading, body };
};
export const extractTranslatableContent = (liveboardData) => {
    const items = [];
    if (liveboardData.name) {
        items.push({
            content: liveboardData.name,
            type: 'Liveboard Title',
        });
    }
    if (liveboardData.description) {
        items.push({
            content: liveboardData.description,
            type: 'Liveboard Description',
        });
    }
    if (liveboardData.tabs) {
        liveboardData.tabs.forEach((tab, index) => {
            if (tab.name) {
                items.push({
                    content: tab.name,
                    type: `Tab ${index + 1} Name`,
                });
            }
        });
    }
    if (liveboardData.views) {
        liveboardData.views.forEach((view, index) => {
            if (view.name) {
                items.push({
                    content: view.name,
                    type: `View ${index + 1} Name`,
                });
            }
        });
    }
    if (liveboardData.containers) {
        let vizIndex = 0;
        let noteIndex = 0;
        liveboardData.containers.forEach(container => {
            const isNoteTile = container.type === 'NOTE_TILE';
            if (isNoteTile) {
                noteIndex += 1;
                if (container.noteTile?.htmlParsedString) {
                    const { heading, body } = parseNoteTileHtml(container.noteTile.htmlParsedString);
                    if (heading) {
                        items.push({
                            content: heading,
                            type: `Note Tile ${noteIndex} Heading`,
                        });
                    }
                    if (body) {
                        items.push({
                            content: body,
                            type: `Note Tile ${noteIndex} Body`,
                        });
                    }
                }
            }
            else {
                vizIndex += 1;
                if (container.name) {
                    items.push({
                        content: container.name,
                        type: `Visualization ${vizIndex} Title`,
                    });
                }
                if (container.description) {
                    items.push({
                        content: container.description,
                        type: `Visualization ${vizIndex} Description`,
                    });
                }
                if (container.answerName &&
                    container.answerName !== container.name) {
                    items.push({
                        content: container.answerName,
                        type: `Answer ${vizIndex} Title`,
                    });
                }
            }
        });
    }
    return items;
};
export const generateTranslationCSV = (items) => {
    const header = 'content,locale,translated-content';
    const rows = items.map(item => `${escapeCSVField(item.content)},,`);
    return [header, ...rows].join('\n');
};
export const downloadLiveboardTranslations = async (liveboardsData) => {
    const dataArray = Array.isArray(liveboardsData)
        ? liveboardsData
        : [liveboardsData];
    const allItems = dataArray.flatMap(lb => extractTranslatableContent(lb));
    if (allItems.length === 0) {
        return;
    }
    const csvContent = generateTranslationCSV(allItems);
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download =
        dataArray.length === 1
            ? `${dataArray[0].name || 'liveboard'}_translations.csv`
            : 'liveboards_translations.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};
//# sourceMappingURL=liveboard-translation-download.util.js.map